import { render, staticRenderFns } from "./_DispatchTypeDialog.vue?vue&type=template&id=a5b5939c&scoped=true"
import script from "./_DispatchTypeDialog.vue?vue&type=script&lang=ts"
export * from "./_DispatchTypeDialog.vue?vue&type=script&lang=ts"
import style0 from "./_DispatchTypeDialog.vue?vue&type=style&index=0&id=a5b5939c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b5939c",
  null
  
)

export default component.exports